import React from 'react';
import CatalogGridSkeleton from '../catalog/CatalogGridSkeleton';

/**
 * Storefront page loading — spinner or structured skeleton by variant.
 */
export default function StorePageLoading({
  message = 'Loading…',
  variant = 'spinner',
  className = '',
}) {
  if (variant === 'account') {
    return (
      <div className={`account-page store-page-loading store-page-loading--account ${className}`.trim()} aria-busy="true">
        <div className="container account-page__container">
          <div className="account-skeleton-hero">
            <div className="catalog-skeleton__line account-skeleton-hero__line--eyebrow" />
            <div className="catalog-skeleton__line account-skeleton-hero__line--title" />
            <div className="catalog-skeleton__line account-skeleton-hero__line--lead" />
          </div>
          <div className="account-skeleton-tiles">
            {[1, 2, 3].map((i) => (
              <div key={i} className="account-skeleton-tile">
                <div className="catalog-skeleton__line account-skeleton-tile__line" />
              </div>
            ))}
          </div>
          <p className="visually-hidden">{message}</p>
        </div>
      </div>
    );
  }

  if (variant === 'checkout') {
    return (
      <div className={`store-page store-page-loading store-page-loading--checkout ${className}`.trim()} aria-busy="true">
        <div className="container store-page__container py-4">
          <div className="checkout-skeleton-progress" />
          <div className="checkout-skeleton-panel">
            <div className="catalog-skeleton__line checkout-skeleton-panel__line--title" />
            <div className="catalog-skeleton__line checkout-skeleton-panel__line" />
            <div className="catalog-skeleton__line checkout-skeleton-panel__line" />
            <div className="catalog-skeleton__line checkout-skeleton-panel__line--short" />
          </div>
          <p className="visually-hidden">{message}</p>
        </div>
      </div>
    );
  }

  if (variant === 'exhibitions') {
    return (
      <div className="exhibitions-page-loading exhibitions-page-loading--skeleton" role="status" aria-busy="true">
        <div className="catalog-skeleton__line exhibitions-page-loading__line--title" />
        <div className="catalog-skeleton__line exhibitions-page-loading__line--subtitle" />
        <div className="exhibitions-page-loading__cards">
          {[1, 2].map((i) => (
            <div key={i} className="exhibitions-page-loading__card" />
          ))}
        </div>
        <p className="visually-hidden">{message}</p>
      </div>
    );
  }

  if (variant === 'grid') {
    return (
      <div className={className} aria-busy="true">
        <CatalogGridSkeleton count={6} />
        <p className="visually-hidden">{message}</p>
      </div>
    );
  }

  return (
    <div className={`store-page store-page--loading store-page-loading ${className}`.trim()} aria-busy="true">
      <div className="store-page-loading__inner">
        <div className="spinner-border text-secondary store-page-loading__spinner" role="status" aria-hidden="true" />
        <p className="store-page-loading__message small text-muted mb-0">{message}</p>
      </div>
    </div>
  );
}
